export const de = {
  title: 'Diese Gebiete werden 2070 von extremer Hitze betroffen sein',
  lead: 'Regionen mit einer mittleren Jahrestemperatur über 29°C',
  introSentence: 'Szenario für die globale Erwärmung wählen:',
  temperatureLabels: [
    {
      temp: '+1,5°C',
      probabilitySentence: 'sehr unwahrscheinliches Szenario',
      description: (
        <>
          Im Jahr 2070 werden etwa <b>419 Millionen</b> Menschen zu heiss haben.
          <br /> Das entspricht <b>4 Prozent</b> der Weltbevölkerung.
        </>
      ),
    },
    {
      temp: '+1,8°C',
      probabilitySentence: 'sehr unwahrscheinliches Szenario',
      description: (
        <>
          Im Jahr 2070 werden etwa <b>680 Millionen</b> Menschen zu heiss haben.
          <br /> Das entspricht <b>7 Prozent</b> der Weltbevölkerung.
        </>
      ),
    },
    {
      temp: '+2,0°C',
      probabilitySentence: 'unwahrscheinliches Szenario',
      description: (
        <>
          Im Jahr 2070 werden etwa <b>823 Millionen</b> Menschen zu heiss haben.
          <br /> Das entspricht <b>9 Prozent</b> der Weltbevölkerung.
        </>
      ),
    },
    {
      temp: '+2,4°C',
      probabilitySentence: 'mögliches Szenario',
      description: (
        <>
          Im Jahr 2070 werden etwa <b>1,3 Milliarden</b> Menschen zu heiss
          haben.
          <br /> Das entspricht <b>14 Prozent</b> der Weltbevölkerung.
        </>
      ),
    },
    {
      temp: '+2,7°C',
      probabilitySentence: 'wahrscheinlichstes Szenario',
      description: (
        <>
          Im Jahr 2070 werden etwa <b>2 Milliarden</b> Menschen zu heiss haben.
          <br /> Das entspricht <b>21 Prozent</b> der Weltbevölkerung.
        </>
      ),
    },
    {
      temp: '+3,6°C',
      probabilitySentence: 'unwahrscheinliches Szenario',
      description: (
        <>
          Im Jahr 2070 werden etwa <b>3,3 Milliarden</b> Menschen zu heiss
          haben.
          <br /> Das entspricht <b>35 Prozent</b> der Weltbevölkerung.
        </>
      ),
    },
  ],
}
export const fr = {
  title: 'Ces régions seront touchées par une chaleur extrême en 2070',
  lead: 'Régions avec une température annuelle moyenne supérieure à 29°C',
  introSentence: ' Choisir un scénario pour le réchauffement climatique:',
  temperatureLabels: [
    {
      temp: '+1,5°C',
      probabilitySentence: 'scénario fort improbable',
      description: (
        <>
          En 2070, environ <b>419 millions</b> de personnes auront trop chaud.
          <br /> Cela correspond à <b>4%</b> de la population mondiale.
        </>
      ),
    },
    {
      temp: '+1,8°C',
      probabilitySentence: 'scénario fort improbable',
      description: (
        <>
          En 2070, environ <b>680 millions</b> de personnes auront trop chaud.
          <br /> Cela correspond à <b>7%</b> de la population mondiale.
        </>
      ),
    },
    {
      temp: '+2,0°C',
      probabilitySentence: 'scénario improbable',
      description: (
        <>
          En 2070, environ <b>823 millions</b> de personnes auront trop chaud.
          <br /> Cela correspond à <b>9%</b> de la population mondiale.
        </>
      ),
    },
    {
      temp: '+2,4°C',
      probabilitySentence: 'scénario possible',
      description: (
        <>
         En 2070, environ <b>1,3 milliard</b> de personnes auront trop chaud.
          <br /> Cela correspond à <b>14%</b> de la population mondiale.
        </>
      ),
    },
    {
      temp: '+2,7°C',
      probabilitySentence: 'scénario le plus probable',
      description: (
        <>
          En 2070, environ <b>2 milliards</b> de personnes auront trop chaud.
          <br /> Cela correspond à <b>21%</b> de la population mondiale.
        </>
      ),
    },
    {
      temp: '+3,6°C',
      probabilitySentence: 'scénario improbable',
      description: (
        <>
          En 2070, environ <b>3,3 milliards</b> de personnes auront trop chaud.
          <br /> Cela correspond à <b>35%</b> de la population mondiale.
        </>
      ),
    },
  ]
}
